import Button from '@widgets/button/button';
import React from 'react';
export default function CardLink({ color, image, title, url_props, url }) {
    return React.createElement("div", { className: "ltg-card-link" },
        React.createElement("div", { className: "ltg-card-link-img-wrap" },
            React.createElement("img", { className: 'ltg-card-link-img', src: image === null || image === void 0 ? void 0 : image.url, alt: (image === null || image === void 0 ? void 0 : image.alt) || title })),
        React.createElement(Button, { color: color || 'white', title: title, url: url || (url_props === null || url_props === void 0 ? void 0 : url_props.url), block: "yes", chevron: 'yes' }));
}
